import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
const GradientCard = styled(Box)(({ theme }) => {
  return {
    backgroundColor: "white",
    color: "#fff",
    padding: "13px",
    height: theme.spacing(12),
    borderRadius: "15px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      transform: "scale(1.01)",
      boxShadow: "0 5px 5px rgba(0, 0, 0, 0.3)",
    },
  };
});


const VisibleSectionWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  height: "100%",
  padding: "15px 15px 15px 20px",
  borderRadius: "15px",
  position: "relative",
  backgroundColor: "#e5e5e5",
  color: "black",
  zIndex: 1,
  border: "3px solid #00f2fe",
}));

const CardComponent = ({ title, total, clickFunction }) => {
  return (
    <>
      <GradientCard onClick={() => clickFunction()}>
        <VisibleSectionWrapper>
          <Typography sx={{ color: "#0c4446" }} variant="overline">
            {title}
          </Typography>
          <Typography
            fontWeight="bold"
            sx={{
              display: "inline-block", // allows width to adjust to content
              fontFamily: "Public Sans, sans-serif",
              backgroundColor: "white",
              color: "#0c4446",
              p:1,
              borderRadius: "5px",
              fontSize: "0.9rem",
              letterSpacing: "1px",
              textAlign: "center",
              border: "1px solid #00f2fe",
              whiteSpace: "nowrap", // ensures number stays in one line
              minWidth: "120px", // minimum width to ensure space for number
            }}
          >
            {total}
          </Typography>
        </VisibleSectionWrapper>
      </GradientCard>
    </>
  );
};

export default CardComponent;
